import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { submitCanvasMessage } from '../../lib/publicApi';
import './public.css';

const MAX_MESSAGE = 300;

export default function SubmitMessagePage() {
  const { domain } = useParams();
  const [senderName, setSenderName] = useState('');
  const [messageBody, setMessageBody] = useState('');
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSending(true);
    try {
      await submitCanvasMessage(domain, senderName.trim(), messageBody.trim());
      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setSending(false);
    }
  };

  if (sent) {
    return (
      <div className="pub-submit-shell">
        <div className="pub-submit-card">
          <h1>Message sent 🎉</h1>
          <p className="pub-subtitle">
            Head back to the canvas to watch your message join the others.
          </p>
          <Link to={`/${domain}`} className="pub-btn" style={{ display: 'block', textAlign: 'center', textDecoration: 'none' }}>
            View the canvas
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="pub-submit-shell">
      <div className="pub-submit-card">
        <h1>Leave a message</h1>
        <p className="pub-subtitle">Your name and message will appear as a new light on the canvas.</p>
        {error && <div className="pub-alert">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="pub-field">
            <label htmlFor="sender_name">Your name</label>
            <input
              id="sender_name"
              value={senderName}
              onChange={(e) => setSenderName(e.target.value)}
              maxLength={60}
              required
              autoFocus
            />
          </div>
          <div className="pub-field">
            <label htmlFor="message_body">Your message</label>
            <textarea
              id="message_body"
              value={messageBody}
              onChange={(e) => setMessageBody(e.target.value.slice(0, MAX_MESSAGE))}
              required
            />
            <span className="pub-char-count">{messageBody.length}/{MAX_MESSAGE}</span>
          </div>
          <button type="submit" className="pub-btn" disabled={sending || !senderName.trim() || !messageBody.trim()}>
            {sending ? 'Sending…' : 'Send'}
          </button>
        </form>
      </div>
    </div>
  );
}
